import Footer from '@/components/Footer';
import Header from '@/components/Header';
import ContactUs from '@/components/Relation/ContactUs';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';


const ContactUsPage: NextPage = () => {

  return (
    <>
      <NextSeo
        title='MOOIMOM | Hubungi Kami'
        description='Silakan hubungi kami untuk memberikan kritik / saran, pertanyaan seputar transaksi, hingga laporan mengenai layanan kami. MOOIMOM akan selalu setia membalas setiap pertanyaan dari customer dengan baik.'
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/contact-us"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/homepage.jpg",
            width: 200,
            height: 200,
            alt: 'MOOIMOM image',
          }]
        }}
      />
      <Header />
      <ContactUs />
      <Footer />
    </>
  )
}

export default ContactUsPage
